import { useContext } from 'react';
import LoadingContext from 'src/contexts/LoadingContext';

const useLoading = () => {
  return useContext(LoadingContext);
};

export default useLoading;
